import Model from '@/models/Model'

export default class SlCustomerAccount extends Model {
    resource() {
        return 'sl_customer_account'
    }
}